import Modal from '../Partials/Modal';
import { useQuery } from '../../../services/Util';

export default function ImagegalleryModal({}) {
	const query = useQuery();

	const url = query.get('url');
	const title = query.get('title');
	const alt = query.get('alt');

	return (
		<Modal title={title}>
			<img src={url} alt={alt} className="d-block w-100" />
		</Modal>
	);
}
